module.exports = __webpack_public_path__ + "img/pubgm-hs-bg.8289df4.png";